import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { ForgotPasswordPageComponent } from './pages/forgot-password-page/forgot-password-page.component';
import { RegisterPageComponent } from './pages/register-page/register-page.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { AuthenticationPageComponent } from './pages/authentication-page/authentication-page.component';
import { AllInOneAuthPageComponent } from './pages/all-in-one-auth-page/all-in-one-auth-page.component';

const routes: Routes = [
  {
    path: '',
    component: AuthenticationPageComponent
  },
  {
    path: 'fullauth',
    component: AllInOneAuthPageComponent
  },
  {
    path: 'login',
    component: LoginPageComponent
  },
  {
    path: ':language/login',
    component: LoginPageComponent
  },

  {
    path: 'register',
    component: RegisterPageComponent
  },
  {
    path: ':language/register',
    component: RegisterPageComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }